// eslint-disable-next-line
import { RouteView } from '@/layouts'

export const serviceRouter = [
  {
    path: '/service',
    redirect: '/service/serviceList',
    component: RouteView,
    meta: { title: '服务', keepAlive: true, icon: 'appstore' },
    name:'serviceGroup',
    children: [
      {
        path: '/service/operation',
        component: RouteView,
        redirect: '/service/serviceList',
        meta: { title: '运营服务', keepAlive: true },
        name:'serviceOperationGroup',
        children: [
          {
            path: '/service/list/new',
            name: 'ServiceListNew',
            component: () => import('@/views/service_new/sms/ServiceList'),
            meta: { title: '服务列表', keepAlive: false}
          },
          {
            path: '/tool/sms',
            name: 'SmsServiceNew',
            hidden: true, // 不显示在菜单上，从服务列表卡片跳转进入
            hidePermissionTree: true,
            ignorePermissions: true,
            component: () => import('@/views/service_new/sms/SmsService'),
            meta: { title: '短信服务', keepAlive: false, hideInMenu: true, hidePermissionTree: true, ignorePermissions: true }
          },
          {
            path: '/tool/marketingActivity',
            name: 'AiMarketingService',
            hidden: true, // 不显示在菜单上，从服务列表卡片跳转进入
            hidePermissionTree: true,
            ignorePermissions: true,
            component: () => import('@/views/service_new/aiMarketing/AiMarketingService'),
            meta: { title: 'AI营销活动', keepAlive: true,hideInMenu: true, hidePermissionTree: true, ignorePermissions: true }
          },
          {
            path: '/tool/marketingActivity/create',
            name: 'ActivityBasicInfo',
            hidden: true,
            hidePermissionTree: true,
            ignorePermissions: true,
            component: () => import('@/views/service_new/aiMarketing/components/ActivityBasicInfo'),
            meta: { title: '新建活动', keepAlive: false,hideInMenu: true, hidePermissionTree: true, ignorePermissions: true }
          },
          {
            path: '/tool/subscribe',
            name: 'Subscription',
            hidden: true, // 不显示在菜单上，从服务列表卡片跳转进入
            hidePermissionTree: true,
            ignorePermissions: true,
            component: () => import('@/views/subscribe/Subscription'),
            meta: { title: '小程序服务', keepAlive: false, hideInMenu: true, hidePermissionTree: true, ignorePermissions: true }
          },
          {
            path: '/service/myService',
            name: 'MyService',
            component: () => import('@/views/service/MyService'),
            meta: { title: '我的服务', keepAlive: false }
          },
          {
            path: '/service/serviceList',
            name: 'ServiceList',
            component: () => import('@/views/service/ServiceList'),
            meta: { title: '全部服务', keepAlive: true }
          },
          {
            path: '/tool/coupon',
            name: 'CouponList',
            hidden: true,
            component: () => import('@/views/service_new/coupon/CouponList'),
            meta: { title: '优惠券', keepAlive: true,hideInMenu: true, hidePermissionTree: true, ignorePermissions: true }
          },
          {
            path: '/tool/advertisement',
            name: 'Advertisement',
            hidden: true, // 不显示在菜单上，从服务列表卡片跳转进入
            hidePermissionTree: true,
            ignorePermissions: true,
            component: () => import('@/views/service_new/advertisement/Advertisement'),
            meta: { title: '广告管理', keepAlive: false, hideInMenu: true, hidePermissionTree: true, ignorePermissions: true }
          },
          {
            path: '/tool/advertisement/create',
            name: 'AdvertisementCreate',
            hidden: true,
            hidePermissionTree: true,
            ignorePermissions: true,
            component: () => import('@/views/service_new/advertisement/AdvertisementCreate'),
            meta: { title: '新建广告', keepAlive: false, hideInMenu: true, hidePermissionTree: true, ignorePermissions: true }
          },
          {
            path: '/tool/travelMade',
            name: 'TravelMode',
            hidden: true, // 不显示在菜单上，从服务列表卡片跳转进入
            hidePermissionTree: true,
            ignorePermissions: true,
            component: () => import('@/views/service_new/travel/TravelMode'),
            meta: { title: '定制游服务', keepAlive: true, hideInMenu: true, hidePermissionTree: true, ignorePermissions: true }
          },
          {
            path: '/tool/travelMade/new',
            name: 'TravelNewOrder',
            hidden: true,
            hidePermissionTree: true,
            ignorePermissions: true,
            component: () => import('@/views/service/serviceProvider/customTravel/NewOrders'),
            meta: { title: '新建定制游订单', keepAlive: true, hideInMenu: true, hidePermissionTree: true, ignorePermissions: true }
          },
          {
            path: '/tool/travelMade/detail',
            name: 'TravelOrderDetail',
            hidden: true,
            hidePermissionTree: true,
            ignorePermissions: true,
            component: () => import('@/views/service/serviceProvider/customTravel/CustomOrderDetails'),
            meta: { title: '订单详情', keepAlive: true, hideInMenu: true, hidePermissionTree: true, ignorePermissions: true }
          },
          {
            path: '/tool/travelMade/batch/create',
            name: 'TravelBatchCreate',
            hidden: true,
            hidePermissionTree: true,
            ignorePermissions: true,
            component: () => import('@/views/service_new/travel/BatchorderCreate'),
            meta: { title: '新建批量设置', keepAlive: false, hideInMenu: true, hidePermissionTree: true, ignorePermissions: true }
          },
          {
            path: '/tool/travelMade/batch/detail',
            name: 'TravelBatchDetail',
            hidden: true,
            hidePermissionTree: true,
            ignorePermissions: true,
            component: () => import('@/views/service_new/travel/BatchorderDetail'),
            meta: { title: '批量设置详情', keepAlive: false, hideInMenu: true, hidePermissionTree: true, ignorePermissions: true }
          },
          {
            hidden: true,
            path: '/service/coupon/couponCreate',
            name: 'CouponCreate',
            hidePermissionTree: true,
            ignorePermissions: true,
            component: () => import('@/views/service_new/coupon/CouponCreate'),
            meta: { title: '新建优惠券', keepAlive: false, hideInMenu: true, hidePermissionTree: true, ignorePermissions: true }
          },
          {
            hidden: true,
            path: '/service/coupon/couponDetail',
            name: 'CouponDetail',
            hidePermissionTree: true,
            ignorePermissions: true,
            component: () => import('@/views/service_new/coupon/CouponDetail'),
            meta: { title: '优惠券详情', keepAlive: false, hideInMenu: true, hidePermissionTree: true, ignorePermissions: true }
          },
          {
            hidden: true,
            path: '/service/coupon/couponBatchDispatch',
            name: 'CouponBatchDispatch',
            hidePermissionTree: true,
            ignorePermissions: true,
            component: () => import('@/views/service_new/coupon/CouponBatchDispatch'),
            meta: { title: '批量派券', keepAlive: false, hideInMenu: true, hidePermissionTree: true, ignorePermissions: true }
          },
          {
            hidden: true,
            path: '/service/coupon/couponRecordList',
            name: 'CouponRecordList',
            hidePermissionTree: true,
            ignorePermissions: true,
            component: () => import('@/views/service_new/coupon/CouponRecordList'),
            meta: { title: '派券记录', keepAlive: false, hideInMenu: true, hidePermissionTree: true, ignorePermissions: true }
          },
          {
            hidden: true,
            path: '/service/serviceDetail',
            name: 'ServiceDetail',
            component: () => import('@/views/service/ServiceDetail'),
            meta: { title: '服务详情', keepAlive: true,hideInMenu: true, hidePermissionTree: true, ignorePermissions: true  }
          },
          {
            path: '/service/orderRecord',
            name: 'OrderRecord',
            component: () => import('@/views/service/OrderRecord'),
            meta: { title: '订购记录', keepAlive: true }
          }
        ]
      },
      {
        path: '/service/sms',
        component: RouteView,
        redirect: '/service/sms/SmsMarketing',
        meta: { title: '短信管理', keepAlive: false },
        name:'serviceSmsGroup',
        children: [
          {
            path: '/service/sms/SmsMarketing',
            name: 'SmsMarketing',
            component: () => import('@/views/service/sms/SmsMarketing'),
            meta: { title: '短信营销(旧)', keepAlive: false }
          },

          {
            path: '/service/sms/smsOrderList',
            name: 'SmsOrderList',
            component: () => import('@/views/service/sms/SmsOrderList'),
            meta: { title: '短信订单(旧)', keepAlive: false }
          },
          {
            path: '/service/sms/sendRecord',
            name: 'SendRecord',
            component: () => import('@/views/service/sms/SendRecord'),
            meta: { title: '发送记录(旧)', keepAlive: false }
          },
          {
            path: '/service/sms/smsSetting',
            name: 'SmsSetting',
            component: () => import('@/views/service/sms/SmsSetting'),
            meta: { title: '短信设置(旧)', keepAlive: false }
          },
          {
            path: '/service/sms/SendSmsMsg',
            name: 'SendSmsMsg',
            hidePermissionTree: true,
            ignorePermissions: true,
            hidden: true,
            component: () => import('@/views/service/sms/SendSmsMsg'),
            meta: { title: '短信营销', keepAlive: false, hideInMenu: true, hidePermissionTree: true, ignorePermissions: true }
          }
        ]
      },
      {
        path: '/service/couponCode',
        component: RouteView,
        name:'couponCodeSmsGroup',
        redirect: '/service/couponCode/couponCodeList',
        meta: { title: '码券管理 ', keepAlive: true },
        children: [
          {
            path: '/service/couponCode/couponCodeList',
            name: 'CouponCodeList',
            component: () => import('@/views/service/couponCode/CouponCodeList'),
            meta: { title: '码券列表', keepAlive: true,
              actions: [
                { key: 'add', permissionId: 'CouponCodeCreator' },
                { key: 'edit', permissionId: 'CouponCodeEditor' },
                { key: 'get', permissionId: 'CouponCodeDetail' },
              ],}
          },
          {
            path: '/service/couponCode/orderList',
            name: 'CouponOrderList',
            component: () => import('@/views/service/couponCode/CouponOrderList'),
            meta: { title: '预约订单', keepAlive: true }
          },
          {
            path: '/service/couponCode/productList',
            name: 'CouponProductList',
            component: () => import('@/views/service/couponCode/CouponProductList'),
            meta: { title: '预约商品', keepAlive: true }
          },
          {
            name: 'CouponOrderDetail',
            path: '/service/couponCode/orderDetail',
            component: () => import('@/views/service/couponCode/CouponOrderDetail'),
            hidden: true,
            meta: { title: '预约订单详情', keepAlive: false, hideInMenu: true, }
          },
          {
            name: 'CouponCodeDetail',
            path: '/service/couponCode/couponCodeDetail',
            component: () => import('@/views/service/couponCode/CouponCodeDetail'),
            hidden: true,
            meta: { title: '码券详情', keepAlive: false, hideInMenu: true ,hidePermissionTree: true,}
          },
          {
            name: 'CouponCodeCreator',
            path: '/service/couponCode/creator',
            component: () => import('@/views/service/couponCode/CouponCodeCreator'),
            hidden: true,
            meta: { title: '新建券码', keepAlive: false, hideInMenu: true ,hidePermissionTree: true, }
          },
          {
            name: 'CouponCodeEditor',
            path: '/service/couponCode/editor',
            component: () => import('@/views/service/couponCode/CouponCodeCreator'),
            hidden: true,
            meta: { title: '编辑券码', keepAlive: false, hideInMenu: true,hidePermissionTree: true, }
          },
          {
            name: 'CodeDetailList',
            path: '/service/couponCode/codeList',
            component: () => import('@/views/service/couponCode/CodeDetailList'),
            hidden: true,
            meta: { title: '券码详情列表', keepAlive: false, hideInMenu: true, hidePermissionTree: true, ignorePermissions: true },
            ignorePermissions: true,//忽略权限控制(忽略的包括里面的所有孩子)
            hidePermissionTree: true//在权限树中隐藏
          },
          {
            name: 'CouponCodeSetting',
            path: '/service/couponCode/setting',
            component: () => import('@/views/service/couponCode/CouponCodeSetting'),
            hidden: true,
            meta: { title: '预约设置', keepAlive: false, hideInMenu: true }
          },
          {
            name: 'VerificationSetting',
            path: '/service/couponCode/verificationSetting',
            component: () => import('@/views/service/couponCode/VerificationSetting'),
            hidden: true,
            meta: { title: '核销设置', keepAlive: false, hideInMenu: true }
          },
          {
            name: 'GroupingSetting',
            path: '/service/couponCode/groupingSetting',
            component: () => import('@/views/service/couponCode/GroupingSetting'),
            hidden: true,
            meta: { title: '核销设置', keepAlive: false, hideInMenu: true }
          },
          {
            name: 'PackagePriceSetting',
            path: '/service/couponCode/priceSetting',
            component: () => import('@/views/service/couponCode/PackagePriceSetting'),
            hidden: true,
            meta: { title: '价格维护', keepAlive: false, hideInMenu: true }
          }
        ]
      },
      {
        path: '/service/physicalDistribution',
        component: RouteView,
        name:'expressGroup',
        redirect: '/service/couponCode/logisticsPurchasing',
        meta: { title: '快递查询 ', keepAlive: false },
        children: [
          {
            path: '/service/physicalDistribution/logisticsPurchasing',
            name: 'LogisticsPurchasing',
            component: () => import('@/views/service/physicalDistribution/LogisticsPurchasing'),
            meta: { title: '数量购买', keepAlive: false }
          },
          {
            path: '/service/physicalDistribution/usageRecord',
            name: 'LogisticsUsageRecord',
            component: () => import('@/views/service/physicalDistribution/LogisticsUsageRecord'),
            meta: { title: '使用记录', keepAlive: false }
          }
        ]
      }
    ]
  }
]
